<template>
<div class="delivery-list">
		<b-table id="delivery-list-table"
			:fields="preSaleDeliveryRecordListtableTab.preSaleDeliveryRecordListFields"
			:items="preSaleDeliveryRecordListtableTab.preSaleDeliveryRecordListAll"
			primary-key="preSaleDeliveryRecordUuid"
			:sort-by.sync="preSaleDeliveryRecordListtableTab.sortBy"
			:sort-desc.sync="preSaleDeliveryRecordListtableTab.sortDesc"
			no-local-sorting
			small
			bordered
			hover
			show-empty
			empty-text="没有找到匹配的记录"
			caption-top
			:tbody-tr-class="rowClass"
			:busy="preSaleDeliveryRecordListtableTab.isTableBusy">
			<template v-slot:cell(actionButton)="row">
				<b-link :to="{path: '../delivery-list/delivery-list-details', query: { preSaleDeliveryRecordUuid : row.item.preSaleDeliveryRecordUuid }}"
				    target="_blank">查看</b-link>
			</template>
			<template v-slot:cell(preSaleDeliveryRecordCreateAt)="row">
			    <span>{{formatDateTimeString(row.item.preSaleDeliveryRecordCreateAt)}}</span>
			</template>
			<div slot="table-busy" class="text-center text-info my-2">
				<b-spinner class="align-middle"></b-spinner>
				<strong>加载中...</strong>
			</div>
		</b-table>	
	<div class="pageControl">
		<b-pagination v-model="preSaleDeliveryRecordListtableTab.feSearch.limit.conditions.pageStart"
			style="margin-top:20px;"
			:total-rows="preSaleDeliveryRecordListtableTab.feSearch.limit.conditions.total"
			:per-page="preSaleDeliveryRecordListtableTab.feSearch.limit.conditions.pageLength"
			align="center"
			size="sm"
			ellipsis-text="..."
			first-text="首页"
			prev-text="上一页"
			next-text="下一页"
			last-text="尾页"
			limit="10"
			@change="onDeliveryPageChange"></b-pagination>
	</div>
</div>
		
			
	</template>
	<script>
	import api from '@/api/api';

	import { formatDateTimeString } from "@/libs/utils";
	import search from '@/libs/search'

	const PRE_SALE_DELIVERY_RECORD_LIST_FIELDS = Object.freeze([
		{ key: 'billCode', label: '发货单号',},
		{ key: 'sendProductDate', label: '发货日期' ,sortable: true},
		{ key: 'weekSeq', label: '周次' },
		{ key: 'userName', label: '客户账号',},
		{ key: 'userExternalCustomerName', label: '客户名称' },
		{ key: 'userExternalCustomerContactNumber', label: '联系电话',},
		{ key: 'receiptFullAddress', label: '收货地址',},
		{ key: 'mainTotalMoney', label: '总额' },
		{ key: 'preSaleDeliveryRecordStatus', label: '发货状态',sortable: true},
		{ key: 'preSaleDeliveryRecordReceivingStatus', label: '收货状态',sortable: true},
		{ key: 'preSaleDeliveryRecordCreateAt', label: '生成发货单时间',sortable: true},
		{ key: 'actionButton', label: '操作'},
	]);

	const RECORD_STATUS_MAP = Object.freeze({
		0: '待发货',
		1: '已发货',
		2: '关闭'
	});

	const RECEIVING_STATUS_MAP = Object.freeze({
		0: '未收货',
		1: '已收货'
	});

	export default {
	name:'DeliveryList',
	data(){
		const feSearch = search.getSearchParams();
		feSearch.limit.conditions.pageLength = 20;
		return{
			preSaleDeliveryRecordListtableTab:{
				preSaleDeliveryRecordListAll:[],
				isTableBusy: false,
				preSaleDeliveryRecordListFields: PRE_SALE_DELIVERY_RECORD_LIST_FIELDS,
				sortBy: '',
				sortDesc: false,
				feSearch
			},
			fetchTimer: null,
			requestSeq: 0
		}
	},
	mounted(){
		if (!this.checkMemberLogin()) {
			this.$router.push({
				name: 'MemberLogin'
			});
			return;
		};
		this.getPreSaleDeliveryRecordList();
	},
	watch:{
		'preSaleDeliveryRecordListtableTab.sortBy'(){
			this.scheduleGetPreSaleDeliveryRecordList();
		},
		'preSaleDeliveryRecordListtableTab.sortDesc'(){
			this.scheduleGetPreSaleDeliveryRecordList();
		}
	},
	methods:{
		// 引用页面组件发布时间方法
		formatDateTimeString,
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (item.preSaleDeliveryRecordReceivingStatus === '已收货') return 'table-dark'
		},
		recordStatus(status) {
			if (typeof status === 'string') return status;
			return RECORD_STATUS_MAP[status] || '';
		},
		receivingStatus(status) {
			if (typeof status === 'string') return status;
			return RECEIVING_STATUS_MAP[status] || '未知';
		},
		setOrderCondition() {
			const tab = this.preSaleDeliveryRecordListtableTab;
			tab.feSearch.order.enable = false;
			tab.feSearch.order.conditions = [];
			if (tab.sortBy) {
				tab.feSearch.order.enable = true;
				tab.feSearch.order.conditions.push({
					name: tab.sortBy,
					type: tab.sortDesc ? 'desc' : 'asc'
				});
			} else {
				tab.feSearch.order.enable = true;
				tab.feSearch.order.conditions.push({
					name: 'preSaleDeliveryRecordDeliveryDate',
					type: 'desc'
				});
			}
		},
		onDeliveryPageChange(pageNum) {
			search.globalPageOnChange(this.preSaleDeliveryRecordListtableTab.feSearch, pageNum);
			this.getPreSaleDeliveryRecordList();
		},
		scheduleGetPreSaleDeliveryRecordList() {
			if (this.fetchTimer) {
				clearTimeout(this.fetchTimer);
			}
			this.fetchTimer = setTimeout(() => {
				this.getPreSaleDeliveryRecordList();
			}, 150);
		},
		// 获取用户id
		getPreSaleDeliveryRecordList() {
			// 获取发货单数据
			const tab = this.preSaleDeliveryRecordListtableTab;
			const currentSeq = ++this.requestSeq;
			tab.isTableBusy = true;
			this.setOrderCondition();
			tab.feSearch.isSign = 0;
			api.getPreSaleDeliveryRecordListByUuid(tab.feSearch).then(res => {
				if (currentSeq !== this.requestSeq) {
					return;
				}
				tab.isTableBusy = false;
				if (res.code === 0) {
					const data = res.data || {};
					const records = data.records || [];
					tab.preSaleDeliveryRecordListAll = records.map((e) => ({
						...e,
						preSaleDeliveryRecordStatus: this.recordStatus(e.preSaleDeliveryRecordStatus),
						preSaleDeliveryRecordReceivingStatus: this.receivingStatus(e.preSaleDeliveryRecordReceivingStatus)
					}));
					search.globalSetFilterRecordCount(tab.feSearch, data.filterRecordCount);
				}
			})
		},
	}
}	
</script>
<style>
	.delivery-list{margin-top: 20px;}	
	.delivery-list th {
		background-color: #efefef;
		height: 40px;
		line-height: 40px;
	}
	.delivery-list tr{text-align: center;background:#fafafa;}
	.delivery-list th{background:#fafafa;}
	.delivery-list td{font-size: 14px;}
	
	.table thead th {
		vertical-align: bottom;
		border-bottom: 2px solid #dbdbdb;
	}
	
	.table-bordered td,
	.table-bordered th {
		border: 1px solid #dbdbdb;
	}
	
	.table-sm td,
	.table-sm th {
		padding: 10px 5px;
	}
	.table-sm td a {
		color: #00B151;
	}
	/* 页码 */
	.page-item.active .page-link{background-color: #1da25a;border: 1px solid #1da25a;}
	.modal-header{background-color: #1da25a;color: #fff;}
	.content{margin-top: 0px !important;}
</style>



// WEBPACK FOOTER //
// src/view/delivery-list/delivery-list.vue